import { useState } from "react";

// Booking Section - Mobile Optimized with all form fields
const BookingSection = () => {
  const [activeTab, setActiveTab] = useState("aeropuerto");
  const [formData, setFormData] = useState({
    // Service type
    serviceType: "transfer",
    // Travel data
    pickup: "",
    pickupAddress: "",
    destination: "",
    destinationAddress: "",
    date: "",
    time: "",
    flightNumber: "",
    // Passengers and vehicle
    passengers: "1",
    luggage: "0",
    vehiclePreference: "sedan",
    // Child seats
    babySeats: "0",
    childSeats: "0",
    boosters: "0",
    hasPet: false,
    specialLuggage: "",
    // Contact
    name: "",
    email: "",
    phone: "",
    language: "español",
    notes: ""
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ 
      ...formData, 
      [name]: type === 'checkbox' ? checked : value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const bookingData = {
      booking_type: activeTab,
      service_type: formData.serviceType,
      pickup: formData.pickup,
      pickup_address: formData.pickupAddress,
      destination: formData.destination,
      destination_address: formData.destinationAddress,
      date: formData.date,
      time: formData.time,
      flight_number: formData.flightNumber,
      passengers: formData.passengers,
      luggage: formData.luggage,
      vehicle_preference: formData.vehiclePreference,
      baby_seats: formData.babySeats,
      child_seats: formData.childSeats,
      boosters: formData.boosters,
      has_pet: formData.hasPet,
      special_luggage: formData.specialLuggage,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      language: formData.language,
      notes: formData.notes
    };
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/booking`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bookingData)
      });
      
      if (response.ok) {
        alert('✅ ¡Solicitud enviada correctamente!\n\nLe enviaremos su presupuesto personalizado en menos de 1 hora.');
        setFormData({
          serviceType: "transfer", pickup: "", pickupAddress: "", destination: "", destinationAddress: "",
          date: "", time: "", flightNumber: "", passengers: "1", luggage: "0", vehiclePreference: "sedan",
          babySeats: "0", childSeats: "0", boosters: "0", hasPet: false, specialLuggage: "",
          name: "", email: "", phone: "", language: "español", notes: ""
        });
      } else {
        throw new Error('Error al enviar');
      }
    } catch (error) {
      // Fallback to WhatsApp
      const message = encodeURIComponent(
        `Hola, solicito presupuesto:\n` +
        `- Servicio: ${formData.serviceType}\n` +
        `- Recogida: ${formData.pickup} - ${formData.pickupAddress}\n` +
        `- Destino: ${formData.destination} - ${formData.destinationAddress}\n` +
        `- Fecha: ${formData.date} a las ${formData.time}\n` +
        `- Vuelo: ${formData.flightNumber || 'No indicado'}\n` +
        `- Pasajeros: ${formData.passengers}, Maletas: ${formData.luggage}\n` +
        `- Vehículo: ${formData.vehiclePreference}\n` +
        `- Sillas bebé: ${formData.babySeats}, Sillas niño: ${formData.childSeats}, Elevadores: ${formData.boosters}\n` +
        `- Mascota: ${formData.hasPet ? 'Sí' : 'No'}\n` +
        `- Nombre: ${formData.name}\n` +
        `- Email: ${formData.email}\n` +
        `- Teléfono: ${formData.phone}\n` +
        `- Notas: ${formData.notes}`
      );
      window.open(`https://wa.me/34600221794?text=${message}`, "_blank");
    }
  };

  const tabs = [
    { id: "aeropuerto", label: "Transfer Aeropuerto", icon: "fa-plane" },
    { id: "horas", label: "Disposición por Horas", icon: "fa-clock" },
    { id: "tours", label: "Tour Privado", icon: "fa-map-marked-alt" }
  ];

  return (
    <section id="reservar" className="py-16 sm:py-24 px-4" data-testid="booking-section">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl mb-2" style={{ fontFamily: "'Cinzel', serif" }}>
            Solicitud de <span className="gradient-text">Reserva</span>
          </h2>
          <p className="text-lg text-[#c9a962]">Solicitar Presupuesto</p>
          <p className="text-gray-400 text-sm mt-2">
            Complete los datos y le enviaremos su presupuesto personalizado en menos de 1 hora. Sin compromiso.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="glass rounded-2xl p-6 sm:p-8" data-testid="booking-form">
          
          {/* 1. Service Type Tabs */}
          <div className="mb-8">
            <div className="flex flex-wrap justify-center gap-2 sm:gap-3" data-testid="booking-tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-4 sm:px-6 py-2.5 rounded-lg flex items-center gap-2 transition-all text-sm ${
                    activeTab === tab.id
                      ? "bg-[#c9a962] text-[#1a1a2e] font-semibold"
                      : "bg-[#1e1e32] text-gray-300 hover:bg-[#2a2a45]"
                  }`}
                  data-testid={`tab-${tab.id}`}
                >
                  <i className={`fas ${tab.icon}`}></i>
                  <span className="hidden sm:inline">{tab.label}</span>
                  <span className="sm:hidden">{tab.label.split(' ')[0]}</span>
                </button>
              ))}
            </div>
          </div>

          {/* 2. Travel Data */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-[#c9a962] mb-4 flex items-center gap-2">
              <span className="w-7 h-7 bg-[#c9a962] text-[#1a1a2e] rounded-full flex items-center justify-center text-sm font-bold">2</span>
              Datos del Viaje
            </h3>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Punto de recogida *</label>
                <select
                  name="pickup"
                  value={formData.pickup}
                  onChange={handleInputChange}
                  className="luxury-select w-full"
                  required
                >
                  <option value="">Seleccione ubicación</option>
                  <option value="aeropuerto">Aeropuerto Málaga (AGP)</option>
                  <option value="torremolinos">Torremolinos</option>
                  <option value="benalmadena">Benalmádena</option>
                  <option value="fuengirola">Fuengirola</option>
                  <option value="marbella">Marbella</option>
                  <option value="puerto-banus">Puerto Banús</option>
                  <option value="estepona">Estepona</option>
                  <option value="malaga">Málaga Centro</option>
                  <option value="nerja">Nerja</option>
                  <option value="otro">Otra ubicación</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Dirección exacta (hotel, calle, nº)</label>
                <input
                  type="text"
                  name="pickupAddress"
                  value={formData.pickupAddress}
                  onChange={handleInputChange}
                  placeholder="Ej: Hotel Don Carlos, Av. Bulevar Príncipe Alfonso"
                  className="luxury-input w-full"
                />
              </div>

              {activeTab !== "horas" && (
                <>
                  <div>
                    <label className="block text-sm text-gray-400 mb-1.5">Destino *</label>
                    <select
                      name="destination"
                      value={formData.destination}
                      onChange={handleInputChange}
                      className="luxury-select w-full"
                      required
                    >
                      <option value="">Seleccione ubicación</option>
                      <option value="aeropuerto">Aeropuerto Málaga (AGP)</option>
                      <option value="torremolinos">Torremolinos</option>
                      <option value="benalmadena">Benalmádena</option>
                      <option value="fuengirola">Fuengirola</option>
                      <option value="marbella">Marbella</option>
                      <option value="puerto-banus">Puerto Banús</option>
                      <option value="estepona">Estepona</option>
                      <option value="malaga">Málaga Centro</option>
                      <option value="nerja">Nerja</option>
                      <option value="otro">Otra ubicación</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm text-gray-400 mb-1.5">Dirección exacta del destino</label>
                    <input
                      type="text"
                      name="destinationAddress"
                      value={formData.destinationAddress}
                      onChange={handleInputChange}
                      placeholder="Ej: Calle Ramón Areces 12, Marbella"
                      className="luxury-input w-full"
                    />
                  </div>
                </>
              )}

              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Fecha del servicio *</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  className="luxury-input w-full"
                  required
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Hora *</label>
                <input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleInputChange}
                  className="luxury-input w-full"
                  required
                />
              </div>

              {activeTab === "aeropuerto" && (
                <div className="sm:col-span-2">
                  <label className="block text-sm text-gray-400 mb-1.5">Número de vuelo</label>
                  <input
                    type="text"
                    name="flightNumber"
                    value={formData.flightNumber}
                    onChange={handleInputChange}
                    placeholder="Ej: IB1234"
                    className="luxury-input w-full"
                  />
                  <p className="text-xs text-[#c9a962] mt-1">
                    <i className="fas fa-plane mr-1"></i>
                    Monitorizamos su vuelo en tiempo real (incluso si llega tarde)
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* 3. Passengers and Vehicle */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-[#c9a962] mb-4 flex items-center gap-2">
              <span className="w-7 h-7 bg-[#c9a962] text-[#1a1a2e] rounded-full flex items-center justify-center text-sm font-bold">3</span>
              Pasajeros y Vehículo
            </h3>
            
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Nº pasajeros *</label>
                <select
                  name="passengers"
                  value={formData.passengers}
                  onChange={handleInputChange}
                  className="luxury-select w-full"
                >
                  {[1,2,3,4,5,6,7,8].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
              
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Maletas grandes</label>
                <select
                  name="luggage"
                  value={formData.luggage}
                  onChange={handleInputChange}
                  className="luxury-select w-full"
                >
                  {[0,1,2,3,4,5,6].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
            </div>

            {/* Vehicle preference */}
            <label className="block text-sm text-gray-400 mb-2">Tipo de vehículo preferido</label>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div 
                className={`p-4 rounded-xl cursor-pointer transition-all border ${
                  formData.vehiclePreference === 'sedan' 
                    ? 'bg-[#c9a962]/20 border-[#c9a962]' 
                    : 'bg-[#1e1e32] border-transparent hover:border-[#c9a962]/50'
                }`}
                onClick={() => setFormData({...formData, vehiclePreference: 'sedan'})}
              >
                <p className="text-[#c9a962] font-semibold text-sm">1-2 Pasajeros</p>
                <p className="text-white text-xs">Mercedes Clase E / Clase S (Sedan)</p>
              </div>
              
              <div 
                className={`p-4 rounded-xl cursor-pointer transition-all border ${
                  formData.vehiclePreference === 'van' 
                    ? 'bg-[#c9a962]/20 border-[#c9a962]' 
                    : 'bg-[#1e1e32] border-transparent hover:border-[#c9a962]/50'
                }`}
                onClick={() => setFormData({...formData, vehiclePreference: 'van'})}
              >
                <p className="text-[#c9a962] font-semibold text-sm">3 o más Pasajeros</p>
                <p className="text-white text-xs">Mercedes Clase V (Van Premium)</p>
              </div>
              
              <div 
                className={`p-4 rounded-xl cursor-pointer transition-all border ${
                  formData.vehiclePreference === 'group' 
                    ? 'bg-[#c9a962]/20 border-[#c9a962]' 
                    : 'bg-[#1e1e32] border-transparent hover:border-[#c9a962]/50'
                }`}
                onClick={() => setFormData({...formData, vehiclePreference: 'group'})}
              >
                <p className="text-[#c9a962] font-semibold text-sm">+8 Pasajeros</p>
                <p className="text-white text-xs">Consultar modelo y disponibilidad</p>
              </div>
            </div>
            <p className="text-xs text-gray-500 mt-2">Le confirmaremos disponibilidad del modelo exacto</p>
          </div>

          {/* 4. Child Seats and Special Needs */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-[#c9a962] mb-4 flex items-center gap-2">
              <span className="w-7 h-7 bg-[#c9a962] text-[#1a1a2e] rounded-full flex items-center justify-center text-sm font-bold">4</span>
              Sillas y Necesidades Especiales
            </h3>
            
            <p className="text-sm text-gray-400 mb-3">Sillas para niños - Indique cuántas necesita de cada tipo <span className="text-[#25D366]">(gratis)</span></p>
            
            <div className="grid grid-cols-3 gap-3 mb-4">
              <div>
                <label className="block text-xs text-gray-400 mb-1">Silla bebé (0-12 meses)</label>
                <select
                  name="babySeats"
                  value={formData.babySeats}
                  onChange={handleInputChange}
                  className="luxury-select w-full text-sm"
                >
                  {[0,1,2,3].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
              
              <div>
                <label className="block text-xs text-gray-400 mb-1">Silla niño (1-4 años)</label>
                <select
                  name="childSeats"
                  value={formData.childSeats}
                  onChange={handleInputChange}
                  className="luxury-select w-full text-sm"
                >
                  {[0,1,2,3].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
              
              <div>
                <label className="block text-xs text-gray-400 mb-1">Elevador (4-10 años)</label>
                <select
                  name="boosters"
                  value={formData.boosters}
                  onChange={handleInputChange}
                  className="luxury-select w-full text-sm"
                >
                  {[0,1,2,3].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-center gap-3 bg-[#1e1e32] p-3 rounded-lg">
                <input
                  type="checkbox"
                  name="hasPet"
                  checked={formData.hasPet}
                  onChange={handleInputChange}
                  className="w-5 h-5 accent-[#c9a962]"
                />
                <label className="text-sm text-gray-300">
                  <i className="fas fa-paw mr-2 text-[#c9a962]"></i>
                  ¿Viaja con mascota?
                </label>
              </div>
              
              <div>
                <input
                  type="text"
                  name="specialLuggage"
                  value={formData.specialLuggage}
                  onChange={handleInputChange}
                  placeholder="¿Equipaje especial? (golf, esquís...)"
                  className="luxury-input w-full text-sm"
                />
              </div>
            </div>
          </div>

          {/* 5. Contact Data */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-[#c9a962] mb-4 flex items-center gap-2">
              <span className="w-7 h-7 bg-[#c9a962] text-[#1a1a2e] rounded-full flex items-center justify-center text-sm font-bold">5</span>
              Sus Datos de Contacto
            </h3>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Nombre y apellidos *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="luxury-input w-full"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="luxury-input w-full"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Teléfono / WhatsApp *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="+34 600 221 794"
                  className="luxury-input w-full"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Idioma preferido del conductor</label>
                <select
                  name="language"
                  value={formData.language}
                  onChange={handleInputChange}
                  className="luxury-select w-full"
                >
                  <option value="español">Español</option>
                  <option value="english">English</option>
                  <option value="deutsch">Deutsch</option>
                  <option value="français">Français</option>
                  <option value="italiano">Italiano</option>
                </select>
              </div>
              
              <div className="sm:col-span-2">
                <label className="block text-sm text-gray-400 mb-1.5">Notas adicionales</label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  placeholder="Cualquier petición especial: hora estimada de llegada, parada intermedia, motivo del viaje, etc."
                  className="luxury-input w-full h-24 resize-none"
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="btn-primary w-full py-4 text-lg font-semibold"
            data-testid="submit-booking-btn"
          >
            <i className="fas fa-paper-plane mr-2"></i>
            Solicitar Presupuesto
          </button>
          
          <p className="text-center text-xs text-gray-500 mt-3">
            <i className="fas fa-shield-alt mr-1 text-[#25D366]"></i>
            Sin compromiso. Respuesta en menos de 1 hora.
          </p>
        </form>
      </div>
    </section>
  );
};

export default BookingSection;
